import GTM from 'react-gtm-module'

export default GTM
